// extracted by mini-css-extract-plugin
export default {"container":"IOExpressCompletePage-module__container--MwOqV","title":"IOExpressCompletePage-module__title--To-tH","subtitle":"IOExpressCompletePage-module__subtitle--VvJb8"};